import { LinkedCentralSystem } from '@infuse/e-connector/central-system/domain';
import { Ref } from 'vue';
import { CentralSystem as ApiCentralSystem } from '@infuse/api/e-connector/central-system';
import { Axios } from 'axios';

export async function upsertCentralSystemLinkDirect(
  linkedCentralSystem: LinkedCentralSystem,
  isUpserting: Ref<boolean>,
  allCentralSystems: Ref<ApiCentralSystem[]>,
  client: Axios,
  shouldRemoveLink = false,
) {
  isUpserting.value = true;
  try {
    const centralSystem = allCentralSystems.value.find((cs) => cs.id === linkedCentralSystem.centralSystemId);
    if (!centralSystem) {
      throw new Error(`Central system with ID ${linkedCentralSystem.centralSystemId} not found`);
    }

    const linkRequest = {
      centralSystemName: centralSystem.name,
      link: !shouldRemoveLink,
      type: linkedCentralSystem.type,
      customChargePointName: linkedCentralSystem.customChargingStationName || undefined,
      commandsAllowed: linkedCentralSystem.commandsAllowed,
      sessionAuthorizationAllowed: linkedCentralSystem.sessionAuthorizationAllowed,
      forwardBasicAuth: linkedCentralSystem.forwardBasicAuth
    };

    await client.post(`chargepoints/${linkedCentralSystem.chargingStationId}/link`, linkRequest);
  } catch (e) {
    console.error('upsertCentralSystemLink failed:', e);
  } finally {
    isUpserting.value = false;
  }
}
